import i18next from 'i18next';

i18next.addResources('en', 'AdelphiFeints', {
  newFeint: 'Record new feint',
  period: 'Period',
  date: 'Date',
  operator: 'Operator'
});
